export default "__VITE_ASSET__BNXCm9NT__"